<p-dialog header="Select The Target Tongue" *ngIf="isShow" [(visible)]="isShow">
  <div class="tongue-menu">
    <div class="tongue-container">
      <ng-container *ngFor="let category of tongues">
        <div class="tongue-type">{{category.type}}</div>
        <div class="tongue-item-block">
          <div class="tongue-item" *ngFor="let tongue of category.tongues" (click)="onSelect(tongue)">
            <div>
              <img [src]="tongue.imageUrl" alt="tongue icon">
            </div>
            <div>
              {{tongue.name}} ({{tongue.count}})
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</p-dialog>
